import { render, staticRenderFns } from "./RegistrationCheck.vue?vue&type=template&id=6c3a2782&"
import script from "./RegistrationCheck.vue?vue&type=script&lang=ts&"
export * from "./RegistrationCheck.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports